export { stateHasWasteCodes } from "./stateWasteCodes";

export const STATES_NOT_FOLLOWING_FEDERAL_GENERATOR_STATUS = [
  "CA",
  "KS",
  "ME",
  "MD",
  "MA",
  "MN",
  "RI",
  "TX",
  "WA",
  "DC",
];
const statesNotFollowingFederalGeneratorStatus = new Set(
  STATES_NOT_FOLLOWING_FEDERAL_GENERATOR_STATUS
);

export const stateDoesNotFollowFederalGeneratorStatus = (
  state: string | null | undefined
): boolean => {
  if (!state) return false;
  return statesNotFollowingFederalGeneratorStatus.has(state.toUpperCase());
};

/**
 * States that do not require OI (Off-site Installation) forms in RCRA flat-file exports.
 * These states do not require destination address or transporter address data for reporting.
 */
export const STATES_WITHOUT_OI_FORMS = ["KS", "MD", "NC", "PA", "WI"];
const statesWithoutOiForms = new Set(STATES_WITHOUT_OI_FORMS);

export const stateRequiresOiForms = (state: string | null | undefined): boolean => {
  if (!state) return true; // Default to requiring OI forms when state is unknown
  return !statesWithoutOiForms.has(state.toUpperCase());
};
